// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueLazyload from "vue-lazyload";
import Mui from 'vue-awesome-mui';
import {getImg} from "./services/urlService";
import CryptoJS from "crypto-js";
import kkUtil from "./assets/js/kk-util";
import Axios from "axios";
import commService from "./services/commService";

Vue.config.productionTip = false;
let jsKey = CryptoJS.enc.Utf8.parse('ZVqAI6jw54IkfLZH');

Vue.use(VueLazyload, {
    adapter: {
      loaded(listener, Init) {
        let reqUrl;
        let responseType;
        let imgPath = listener.el.getAttribute('imgpath');
        if (listener.el.getAttribute('imgtype') === 'vod') {
          //视频图片
          if (imgPath.startsWith('http')) {
            //外部源
            let zoom = listener.el.getAttribute('zoom');
            reqUrl = '/js/' + kkUtil.aesEncryptHex(imgPath, jsKey);
            if (zoom !== null) {
              reqUrl = reqUrl + "/" + zoom;
            }
            reqUrl = reqUrl + '.js';
            reqUrl = getImg(reqUrl);
            responseType = 'text';
          } else {
            //相对路径，自有源
            const match = imgPath.match(/\/([a-f0-9]{32})\//); // 32位的 hex
            if (!match) {
              console.log('url error: ' + imgPath);
              return;
            }
            reqUrl = commService.getLocalInitData().s3VodUrl + '/' + match[1] + '/c.dat';
            responseType = 'arraybuffer';
          }
        } else if (listener.el.getAttribute('imgtype') === 'novel') {
          //xs图片
          const match = imgPath.match(/\/img\/([a-f0-9]+)\.img/); // 32位的 hex
          if (!match) {
            console.log('url error: ' + imgPath);
            return;
          }
          reqUrl = commService.getLocalInitData().s3VodUrl + '/xs/' + kkUtil.md5(listener.el.getAttribute('booktitle')) + "/" + listener.el.getAttribute('chapternum') + "/" + match[1] + '.dat';
          responseType = 'arraybuffer';
        } else {
          //mh图片
          const match = imgPath.match(/\/img\/([a-f0-9]+)\.img/); // 32位的 hex
          if (!match) {
            console.log('url error: ' + imgPath);
            return;
          }
          reqUrl = commService.getLocalInitData().s3VodUrl + '/mh/' + kkUtil.md5(listener.el.getAttribute('booktitle')) + "/" + listener.el.getAttribute('chapternum') + "/" + match[1] + '.dat';
          responseType = 'arraybuffer';
        }
        // //拼接imgserver
        // reqUrl = getImg(reqUrl);

        //请求加密图片
        Axios.create({
          // headers: {
          //   'Content-Type': 'text/plain',
          // },
          responseType: responseType
        }).get(reqUrl).then(res => {
          if (res.status === 200) {
            let base64Str;
            if (responseType === 'arraybuffer') {
              base64Str = kkUtil.aesDecryptBin2Base64(res.data)
            } else {
              base64Str = kkUtil.aesDecrypt(res.data + "", jsKey);
            }
            listener.el.src = "data:image/png;base64," + base64Str;
          } else if (res.status === 204) {
            listener.el.src = require('./assets/img/icon-e.png');
          }
        });
      }
    }
  },
  Mui);

/* eslint-disable no-new */
let vueObj = new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js